import VMasker from 'vanilla-masker';

export const maskCPF = (text) => {
    return VMasker.toPattern(text, '999.999.999-99');
}

export const maskCNPJ = (text = '') => {
    const valor = String(text)
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');

    let resultado = valor;

    if (resultado.length > 2)
        resultado = resultado.substring(0, 2) + '.' + resultado.substring(2);

    if (resultado.length > 6)
        resultado = resultado.substring(0, 6) + '.' + resultado.substring(6);

    if (resultado.length > 10)
        resultado = resultado.substring(0, 10) + '/' + resultado.substring(10);

    if (resultado.length > 15)
        resultado = resultado.substring(0, 15) + '-' + resultado.substring(15);

    return resultado.substring(0, 18);
}

export const maskDate = (text) => {
    return VMasker.toPattern(text, '99/99/9999');
}

export const maskTelefone = (text) => {
    return VMasker.toPattern(text, '(99)99999-9999');
}

export const maskNumber = (text) => {
    return VMasker.toNumber(text);
}

export const maskDecimal = (text) => {
    return VMasker.toMoney(text, {
        // Decimal precision -> "90"
        precision: 2,
        // Decimal separator -> ",90"
        separator: ',',
        // Number delimiter -> "12.345.678"
        delimiter: '.',
        
        // Money unit -> "R$ 12.345.678,90"
        // unit: 'R$',

        // Money unit -> "12.345.678,90 R$"
        // suffixUnit: 'R$',
        
        // Force type only number instead decimal,
        // masking decimals with ",00"
        // Zero cents -> "R$ 1.234.567.890,00"
        zeroCents: true
    });
}


// WEBPACK FOOTER //
// ./src/utils/Masker.js